/**
 * ServiceLocator
 *
 * @hidden
 */
export class ServiceLocator {
    constructor() {
        this.services = {};
    }
    register(name, type) {
        this.services[`${name}`] = type;
    }
    getService(name) {
        return this.services[`${name}`];
    }
}
